<template>
  <div>
    <FlightInfoNav
      :locale="locale"
      :lang="lang" />
    <ScheduleList
      v-if="schedule"
      :locale="locale"
      :lang="lang"
      :list="schedule" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FlightInfoNav from '@/components/FlightInfo/FlightInfoNav.vue'
import ScheduleList from '@/components/FlightInfo/ScheduleList.vue'
export default {
  name: 'FlightSchedule',
  props: [
    'locale',
    'lang'
  ],
  components: {
    FlightInfoNav,
    ScheduleList
  },
  computed: {
    ...mapGetters({
      schedule: 'flightinfo/getFlightSchedule'
    }),
    airport () {
      return this.$route.params.airport
    }
  },
  watch: {
    '$route' (to, from, next) {
      if (to.params.airport !== from.params.airport) {
        this.init()
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    init () {
      const airport = this.airport
      this.$store.commit('loading', true)
      this.$store.dispatch('flightinfo/getFlightSchedule', airport).then(() => {
        this.$store.commit('loading', false)
      })
    },
    onScroll () {
      const scrollOffset = document.documentElement.scrollTop + document.documentElement.clientHeight === document.documentElement.scrollHeight
      if (scrollOffset) {
        this.init()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
